var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6865 8.05796C18.3393 8.05796 18.9774 7.86439 19.5201 7.50173C20.0629 7.13907 20.4859 6.62364 20.7357 6.02056C20.9855 5.41747 21.0509 4.75387 20.9235 4.11364C20.7962 3.4734 20.4818 2.88523 20.0203 2.42364C19.5587 1.96206 18.9706 1.6478 18.3304 1.52045C17.6901 1.3931 17.0265 1.45845 16.4234 1.70826C15.8204 1.95807 15.3049 2.38109 14.9422 2.92385C14.5796 3.46661 14.386 4.10473 14.386 4.75751C14.386 5.63285 14.7337 6.47232 15.3527 7.09128C15.9716 7.71024 16.8111 8.05796 17.6865 8.05796Z",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48599 15.7573C5.13883 15.7576 5.7771 15.5643 6.32007 15.2018C6.86303 14.8393 7.28631 14.324 7.53635 13.7209C7.78638 13.1178 7.85193 12.4541 7.72475 11.8138C7.59757 11.1735 7.28336 10.5853 6.82184 10.1235C6.36032 9.6618 5.77221 9.34726 5.13194 9.21979C4.49166 9.09232 3.82796 9.15756 3.22479 9.40732C2.62161 9.65708 2.10607 10.0801 1.74334 10.6229C1.38061 11.1657 1.18701 11.8039 1.18701 12.4568C1.18701 13.3318 1.53455 14.1711 2.15319 14.7901C2.77183 15.409 3.61091 15.7569 4.48599 15.7573Z",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6865 23.4573C18.3389 23.457 18.9766 23.2633 19.5189 22.9006C20.0612 22.5379 20.4838 22.0226 20.7332 21.4197C20.9827 20.8169 21.0478 20.1537 20.9204 19.5138C20.7929 18.874 20.4786 18.2862 20.0172 17.825C19.5557 17.3638 18.9679 17.0498 18.328 16.9227C17.6881 16.7955 17.0249 16.8609 16.4222 17.1106C15.8194 17.3604 15.3043 17.7832 14.9419 18.3257C14.5794 18.8682 14.386 19.5059 14.386 20.1583C14.3864 21.0334 14.7343 21.8725 15.3532 22.4912C15.9721 23.1098 16.8114 23.4573 17.6865 23.4573Z",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33508 14.1211L14.848 18.4996",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8374 6.41797L7.33508 10.7965",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3a24d791c929e24ede51bfa5790d979e.svg";
export { ForwardRef as ReactComponent };